import './Theme.Table.Simple.scss';
export default 'ThemeTableSimple';
